var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgDisLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C2C2C2",
  fillRule: "evenodd",
  d: "M11.55 16.055c-.143.27-.462.445-.815.445-1.973 0-3.571-1.343-3.571-3v-2.25h-4.46c-.784.006-1.532-.277-2.046-.773C.142 9.979-.087 9.315.03 8.663l1.232-6.75C1.463.805 2.603-.01 3.936 0h10.37c.494 0 .893.336.893.75V9a.65.65 0 0 1-.077.305zm-1.358-1.125 3.222-6.09V1.5H3.92c-.445-.004-.826.268-.893.638l-1.232 6.75a.67.67 0 0 0 .21.604c.171.166.421.26.683.258h5.367c.493 0 .893.336.893.75v3c0 .67.522 1.236 1.243 1.43",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C2C2C2",
  fillRule: "evenodd",
  d: "M16.684 9.834h-2.377c-.493 0-.893-.336-.893-.75V.75c0-.414.4-.75.893-.75h2.377c1.495-.019 2.771.904 2.972 2.15a1 1 0 0 1 .008.1V7.5a1 1 0 0 1-.008.1c-.192 1.196-1.42 2.252-2.972 2.233m1.194-2.39V2.308c-.1-.472-.596-.816-1.171-.807H15.2v6.833h1.507c.52.008 1.062-.369 1.171-.89",
  clipRule: "evenodd"
})));
export default SvgSvgDisLike;